import type { IMetadata } from '@adloid-technologies/discover-sdk';

/**
 * Silverado Configurator (linkId 2371).
 *
 * Converted from the 1.0 repo's `src/metadata/data/metadata-2371.ts`
 * (`appData.visualiser.models[0]`, array-shaped) into the 2.0 object-keyed
 * `IMetadata` shape. Generated — see the conversion notes in ui-metadata.ts.
 */
export const metadata: IMetadata = {
  models: {
    Silverado: {
      id: 'Silverado',
      lightingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      postProcessingIdentifier: {
        interior: 'dome',
        exterior: 'dome'
      },
      backgroundIdentifer: 'dome',
      variants: {
        'high-country-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5329',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5316',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5339',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'zr2-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5333',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5330',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5320',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5347',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'trail-boss-crew-cab-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5327',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5316',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5341',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7103',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'trail-boss-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5327',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5708',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5316',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5535',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            },
            {
              id: 'bed_variant',
              sku: '5352',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'rst-crew-cab-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5332',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5320',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5337',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7103',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'rst-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5332',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5336',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5318',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5534',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'bed_variant',
              sku: '5351',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-crew-cab-4wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5326',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5334',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5320',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5338',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7103',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-4wd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5326',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5336',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5320',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5348',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'bed_variant',
              sku: '5350',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-rwd-2025': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5326',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5336',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5320',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5348',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'high-country-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5329',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5316',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5339',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'zr2-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5333',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5330',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5320',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5347',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'trail-boss-crew-cab-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5327',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5316',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5341',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7103',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'trail-boss-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5327',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5708',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5316',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5535',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            },
            {
              id: 'bed_variant',
              sku: '5352',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'rst-crew-cab-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5332',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '6187',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5337',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7103',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'rst-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5332',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5336',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5318',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5534',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'bed_variant',
              sku: '5351',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-crew-cab-4wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5326',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5334',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5320',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5338',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7103',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-4wd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5326',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5336',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5320',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5348',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'bed_variant',
              sku: '5350',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        },
        'lt-rwd-2026': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5326',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'cab_exterior',
              sku: '5336',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'exterior-color',
              sku: '5320',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'interior-color',
              sku: '5348',
              projectId: '59',
              position: [
                0,
                0,
                0
              ]
            },
            {
              id: 'dome',
              sku: '7105',
              projectId: '59',
              position: [
                0,
                0,
                0
              ],
              maxResolution: {
                ios: '2K',
                android: '4K'
              }
            }
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color'
        }
      },
      backgrounds: {
        // Desert Landscape 1 = Alula Desert: regular cab 7106 here; crew cab trims
        // switch to 7104 via ui-metadata backgroundVariantSkus (see App.tsx).
        g0ZA968_RpUd: {
          isDefault: false,
          sku: '7106',
          project: '59'
        },
        // Desert Landscape 2 = Alula Desert_2: regular cab 7105 here; crew cab trims
        // switch to 7103 via ui-metadata backgroundVariantSkus (see App.tsx).
        g0ZA968_RpUe: {
          isDefault: true,
          sku: '7105',
          project: '59'
        }
      },
      ambientLighting: {
        ambientColors: '',
        ambientLightings: {},
        relevantVariants: []
      },
      colors: {
        interior: {
          tarm9hwgcy55: {
            sku: '5339',
            project: '59',
            relevantVariants: [
              'high-country-2025',
              'high-country-2026'
            ],
            notCompatibleExteriorColors: []
          },
          wolmccxt5hjd: {
            sku: '5347',
            project: '59',
            relevantVariants: [
              'zr2-2025',
              'zr2-2026'
            ],
            notCompatibleExteriorColors: []
          },
          vinl6onp0hdu: {
            sku: '5341',
            project: '59',
            relevantVariants: [
              'trail-boss-crew-cab-2025',
              'trail-boss-crew-cab-2026'
            ],
            notCompatibleExteriorColors: []
          },
          he9ofys2sliq: {
            sku: '5346',
            project: '59',
            relevantVariants: [
              'trail-boss-crew-cab-2025',
              'trail-boss-crew-cab-2026'
            ],
            notCompatibleExteriorColors: []
          },
          nhbc3d6y68kz: {
            sku: '5536',
            project: '59',
            relevantVariants: [
              'trail-boss-2025',
              'trail-boss-2026'
            ],
            notCompatibleExteriorColors: []
          },
          wsycdik891e5: {
            sku: '5535',
            project: '59',
            relevantVariants: [
              'trail-boss-2025',
              'trail-boss-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '73c9e3m5u13v': {
            sku: '5337',
            project: '59',
            relevantVariants: [
              'rst-crew-cab-2025',
              'rst-crew-cab-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '8f1wuj26aml3': {
            sku: '5345',
            project: '59',
            relevantVariants: [
              'rst-crew-cab-2025',
              'rst-crew-cab-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '5ntegqogzttd': {
            sku: '5534',
            project: '59',
            relevantVariants: [
              'rst-2025',
              'rst-2026'
            ],
            notCompatibleExteriorColors: []
          },
          ghaqazjmli4q: {
            sku: '5537',
            project: '59',
            relevantVariants: [
              'rst-2025',
              'rst-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '1z0i3csgxouu': {
            sku: '5338',
            project: '59',
            relevantVariants: [
              'lt-crew-cab-4wd-2025',
              'lt-crew-cab-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          '93wy3qilqcvm': {
            sku: '5343',
            project: '59',
            relevantVariants: [
              'lt-crew-cab-4wd-2025',
              'lt-crew-cab-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          a08fde58dlwj: {
            sku: '5348',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ],
            notCompatibleExteriorColors: []
          },
          f6cooxj7w8ba: {
            sku: '5348',
            project: '59',
            relevantVariants: [
              'lt-rwd-2025',
              'lt-rwd-2026'
            ],
            notCompatibleExteriorColors: []
          }
        },
        exterior: {
          '5c8ep1iwg2jn': {
            sku: '5316',
            project: '59',
            relevantVariants: [
              'high-country-2025',
              'high-country-2026'
            ]
          },
          sn7yhhtw36la: {
            sku: '5322',
            project: '59',
            relevantVariants: [
              'high-country-2025'
            ]
          },
          'sn7yhhtw36la-my26': {
            sku: '6188',
            project: '59',
            relevantVariants: [
              'high-country-2026'
            ]
          },
          fa1g6h4tgwqj: {
            sku: '5318',
            project: '59',
            relevantVariants: [
              'high-country-2025',
              'high-country-2026'
            ]
          },
          nwljddrqlbg2: {
            sku: '5325',
            project: '59',
            relevantVariants: [
              'high-country-2025',
              'high-country-2026'
            ]
          },
          '1vsvpj5pgkpw': {
            sku: '5324',
            project: '59',
            relevantVariants: [
              'high-country-2025',
              'high-country-2026'
            ]
          },
          g6y3sjg30waa: {
            sku: '5320',
            project: '59',
            relevantVariants: [
              'zr2-2025',
              'zr2-2026'
            ]
          },
          isfjjq0k49rf: {
            sku: '5323',
            project: '59',
            relevantVariants: [
              'zr2-2025',
              'zr2-2026'
            ]
          },
          '9i25yo15msgi': {
            sku: '5317',
            project: '59',
            relevantVariants: [
              'zr2-2025'
            ]
          },
          '9i25yo15msgi-my26': {
            sku: '6187',
            project: '59',
            relevantVariants: [
              'zr2-2026'
            ]
          },
          '8keam23mnq98': {
            sku: '5319',
            project: '59',
            relevantVariants: [
              'zr2-2025',
              'zr2-2026'
            ]
          },
          t5iz0qtjiu66: {
            sku: '5316',
            project: '59',
            relevantVariants: [
              'zr2-2025',
              'zr2-2026'
            ]
          },
          kj3h63dvah5v: {
            sku: '5321',
            project: '59',
            relevantVariants: [
              'zr2-2025',
              'zr2-2026'
            ]
          },
          v6j91ri0v3fw: {
            sku: '5323',
            project: '59',
            relevantVariants: [
              'trail-boss-crew-cab-2025',
              'trail-boss-crew-cab-2026'
            ]
          },
          '5t6ycv9d6u2a': {
            sku: '5318',
            project: '59',
            relevantVariants: [
              'trail-boss-crew-cab-2025',
              'trail-boss-crew-cab-2026'
            ]
          },
          pu8ndfz3yuww: {
            sku: '5319',
            project: '59',
            relevantVariants: [
              'trail-boss-crew-cab-2025',
              'trail-boss-crew-cab-2026'
            ]
          },
          anuclcfy65hu: {
            sku: '5316',
            project: '59',
            relevantVariants: [
              'trail-boss-crew-cab-2025',
              'trail-boss-crew-cab-2026'
            ]
          },
          hvd0le9te38d: {
            sku: '5321',
            project: '59',
            relevantVariants: [
              'trail-boss-crew-cab-2025',
              'trail-boss-crew-cab-2026'
            ]
          },
          b1u0be790w3j: {
            sku: '5325',
            project: '59',
            relevantVariants: [
              'trail-boss-crew-cab-2025',
              'trail-boss-crew-cab-2026'
            ]
          },
          uwetia14dlwx: {
            sku: '5323',
            project: '59',
            relevantVariants: [
              'trail-boss-2025',
              'trail-boss-2026'
            ]
          },
          cyxr36xkp8lj: {
            sku: '5318',
            project: '59',
            relevantVariants: [
              'trail-boss-2025',
              'trail-boss-2026'
            ]
          },
          ss2t8loc0zuj: {
            sku: '5319',
            project: '59',
            relevantVariants: [
              'trail-boss-2025',
              'trail-boss-2026'
            ]
          },
          ewtu4bd3e2lk: {
            sku: '5316',
            project: '59',
            relevantVariants: [
              'trail-boss-2025',
              'trail-boss-2026'
            ]
          },
          ew6nnknehod2: {
            sku: '5321',
            project: '59',
            relevantVariants: [
              'trail-boss-2025',
              'trail-boss-2026'
            ]
          },
          '6dyaosyo71jo': {
            sku: '5325',
            project: '59',
            relevantVariants: [
              'trail-boss-2025',
              'trail-boss-2026'
            ]
          },
          '42unzt5oris8': {
            sku: '5320',
            project: '59',
            relevantVariants: [
              'rst-crew-cab-2025'
            ]
          },
          '42unzt5oris8-my26': {
            sku: '6187',
            project: '59',
            relevantVariants: [
              'rst-crew-cab-2026'
            ]
          },
          vm7p16mew3v8: {
            sku: '5323',
            project: '59',
            relevantVariants: [
              'rst-crew-cab-2025',
              'rst-crew-cab-2026'
            ]
          },
          '28kpjqnxlj1g': {
            sku: '5318',
            project: '59',
            relevantVariants: [
              'rst-crew-cab-2025',
              'rst-crew-cab-2026'
            ]
          },
          '6yngtuuz7ba5': {
            sku: '5319',
            project: '59',
            relevantVariants: [
              'rst-crew-cab-2025',
              'rst-crew-cab-2026'
            ]
          },
          tikeuy98bjmx: {
            sku: '5316',
            project: '59',
            relevantVariants: [
              'rst-crew-cab-2025',
              'rst-crew-cab-2026'
            ]
          },
          g59lqemyqzko: {
            sku: '5325',
            project: '59',
            relevantVariants: [
              'rst-crew-cab-2025',
              'rst-crew-cab-2026'
            ]
          },
          g7u1kp5phj7t: {
            sku: '5323',
            project: '59',
            relevantVariants: [
              'rst-2025',
              'rst-2026'
            ]
          },
          vpmrwig8eaal: {
            sku: '5320',
            project: '59',
            relevantVariants: [
              'rst-2025'
            ]
          },
          'vpmrwig8eaal-my26': {
            sku: '6187',
            project: '59',
            relevantVariants: [
              'rst-2026'
            ]
          },
          triu9xb1d3yc: {
            sku: '5318',
            project: '59',
            relevantVariants: [
              'rst-2025',
              'rst-2026'
            ]
          },
          '70r7ym4u3hle': {
            sku: '5319',
            project: '59',
            relevantVariants: [
              'rst-2025',
              'rst-2026'
            ]
          },
          '8007q43snr2r': {
            sku: '5316',
            project: '59',
            relevantVariants: [
              'rst-2025',
              'rst-2026'
            ]
          },
          qwbx50kclek6: {
            sku: '5325',
            project: '59',
            relevantVariants: [
              'rst-2025',
              'rst-2026'
            ]
          },
          g8bcl2qhhvar: {
            sku: '5320',
            project: '59',
            relevantVariants: [
              'lt-crew-cab-4wd-2025',
              'lt-crew-cab-4wd-2026'
            ]
          },
          '2d29kh3p8f8j': {
            sku: '5323',
            project: '59',
            relevantVariants: [
              'lt-crew-cab-4wd-2025',
              'lt-crew-cab-4wd-2026'
            ]
          },
          '7h2h723sv74i': {
            sku: '5318',
            project: '59',
            relevantVariants: [
              'lt-crew-cab-4wd-2025',
              'lt-crew-cab-4wd-2026'
            ]
          },
          ecwytnxf0hxy: {
            sku: '5319',
            project: '59',
            relevantVariants: [
              'lt-crew-cab-4wd-2025',
              'lt-crew-cab-4wd-2026'
            ]
          },
          sekelomxqqwv: {
            sku: '5316',
            project: '59',
            relevantVariants: [
              'lt-crew-cab-4wd-2025',
              'lt-crew-cab-4wd-2026'
            ]
          },
          w5asg0j1keaw: {
            sku: '5317',
            project: '59',
            relevantVariants: [
              'lt-crew-cab-4wd-2025'
            ]
          },
          'w5asg0j1keaw-my26': {
            sku: '5321',
            project: '59',
            relevantVariants: [
              'lt-crew-cab-4wd-2026'
            ]
          },
          k550ufl2z63j: {
            sku: '5320',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          gxqxsxnaljfj: {
            sku: '5323',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          l415icrduyfe: {
            sku: '5318',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          t0ah6d0ze4xe: {
            sku: '5319',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          ew6nnknehod1: {
            sku: '5316',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025',
              'lt-4wd-2026'
            ]
          },
          ew6nnknehod8: {
            sku: '5325',
            project: '59',
            relevantVariants: [
              'lt-4wd-2025'
            ]
          },
          'ew6nnknehod8-my26': {
            sku: '5321',
            project: '59',
            relevantVariants: [
              'lt-4wd-2026'
            ]
          },
          fkyrlr7clfu8: {
            sku: '5320',
            project: '59',
            relevantVariants: [
              'lt-rwd-2025',
              'lt-rwd-2026'
            ]
          },
          g6w0v7586nep: {
            sku: '5323',
            project: '59',
            relevantVariants: [
              'lt-rwd-2025',
              'lt-rwd-2026'
            ]
          },
          frv70rwooeqs: {
            sku: '5318',
            project: '59',
            relevantVariants: [
              'lt-rwd-2025',
              'lt-rwd-2026'
            ]
          },
          hx1107tranuw: {
            sku: '5319',
            project: '59',
            relevantVariants: [
              'lt-rwd-2025',
              'lt-rwd-2026'
            ]
          },
          xa5qgss7of58: {
            sku: '5316',
            project: '59',
            relevantVariants: [
              'lt-rwd-2025',
              'lt-rwd-2026'
            ]
          },
          '6dlgbe69b79c': {
            sku: '5325',
            project: '59',
            relevantVariants: [
              'lt-rwd-2025'
            ]
          },
          '6dlgbe69b79c-my26': {
            sku: '5321',
            project: '59',
            relevantVariants: [
              'lt-rwd-2026'
            ]
          },
        }
      },
      features: {
        qlpcncqd64b7: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front_Grill',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Grill',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kh1xk6tsachr: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '2uhaenqtv8gj': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_20in_Alloy_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1slkxz7syxvp': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'Bed',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kbns5f4ez323: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_Side_Step',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Side Step',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        okpcdfyxu7lo: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'Tailgate',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        wh2pdteldd7b: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        sulp9ugcljsd: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '14ojjvbzhg1q': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_door_speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Door Speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            a8jlgfd8evx4: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        '1i87rvwcyk2a': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        xje8k6tk6c08: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'Wireless Charging',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Wireless Charging',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        xsdac8nojc1s: {
          type: 'graphic',
          view: 'interior',
          // Hidden: clicking it does nothing (the underlying Headrest/SHADER_Headrest
          // clip never fires - confirmed identical to 1.0, so not a migration
          // regression; likely missing on the 3D asset itself). Emptying
          // relevantVariants removes it from useGetCurrentConfigData's feature
          // filter for every trim, so it no longer appears in the UI at all,
          // without deleting the entry - restore the two ids below if the clip
          // is ever fixed on the asset.
          relevantVariants: [
            // 'high-country-2025',
            // 'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headrest',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headrest',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ddlwz0n6pzn8: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_Sill Badge',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Sill Badge',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            a8jlgfd8evx4: {
              add: true,
              snapToLastFrame: true
            }
          }
        },
        '9cffzj69hili': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          messages: [
            {
              message: 'SHADER_Console',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Console',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        aseriz822crx: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front_Grill',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Grill',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '9ram7z0rq7yd': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Alloy_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ztt94zgq6tv2: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        x5bxbjca4a53: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          messages: [
            {
              message: 'SHADER_Fender_Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Fender Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '0bpm6r7t120n': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          messages: [
            {
              message: 'SHADER_Rear_Bumper_ZR2',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Rear Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        v2eva244szp6: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          messages: [
            {
              message: 'SHADER_Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Seats',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '4jf6vmtzqseb': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen Car Play',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '7h7ahk43t9t6': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '5b5qyf2dkc3d': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          messages: [
            {
              message: 'Door Speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_door_speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            '7p1u0cgedxiz': {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        r8p8s0tba94a: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Alloy_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '67hwcwhf1291': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        vkxy3mgo24us: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front_Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ik1a0znz2yvr: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_Fender_Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Fender Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '6kfn70dpldgt': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          messages: [
            {
              message: 'Exhausts',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        xwcjbwuemmg9: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen Car Play',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        w8k27psfeex9: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '7alln8x64kl2': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          messages: [
            {
              message: 'Door Speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_door_speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            '8dvmfe5qick4': {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        gok6ybzvijl3: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Alloy_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        aor43nna2081: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        bghvqv1oxwq3: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front_Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        kh1xk6tsachv: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          messages: [
            {
              message: 'Exhausts',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        b3wyhh9ssmp5: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen Car Play',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        tpor5yrdiomu: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        zc3f877ep5fv: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          messages: [
            {
              message: 'Door Speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_door_speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            m34u55h0srjx: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        kjzeywh6bhmc: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          messages: [
            {
              message: 'Front Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        hbjabs5a19ly: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front_Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        tw7ymfa9bxbe: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_DRL',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'DRL',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        cj51eb7h876w: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          messages: [
            {
              message: 'Bed',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '3ahtspa15nlz': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen Car Play',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '5s66ctsekqb9': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '9011oiubpuej': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          messages: [
            {
              message: 'Door Speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_door_speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            sk4ftvul6hgw: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        '48s1xhz7jk96': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          messages: [
            {
              message: 'Steering Wheel Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Steering_Wheel_logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '2ostbx6tot3q': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          messages: [
            {
              message: 'Front Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '989gromic7l7': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front_Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '80pysz4ealuh': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          messages: [
            {
              message: 'SHADER_DRL',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'DRL',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        uxjy77kpsykc: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          messages: [
            {
              message: 'Bed',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        qqai4ydjh6oy: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen Car Play',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        zlpprqne1dyg: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        y6zcqp9r8fln: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          messages: [
            {
              message: 'Door Speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_door_speaker',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {
            ekb9gx2zypw8: {
              add: false,
              snapToLastFrame: true
            }
          }
        },
        '3ahd3ud1cxvf': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          messages: [
            {
              message: 'Steering Wheel Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Steering_Wheel_logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1kmk7x0zr7yd': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          messages: [
            {
              message: 'Front Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        j09x4tjlksiq: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Alloy_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        rwj9cz2t4kgs: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        f0rf1nsdn3mr: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front_Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        vvi10af2yeqo: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          messages: [
            {
              message: 'Bed',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        tauk6dp0vcf3: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen Car Play',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        u9pqnc3jhbhx: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        twsbc3te9m0w: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          messages: [
            {
              message: 'Steering Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Steering_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        m1m4h0l2cqeo: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'Front Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ylam62d7djz9: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Alloy_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        h7hoq4zvkx1d: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        h8b41kjneur6: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front_Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        wog0ubyk7gkm: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'Bed',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '1dozmck8mjut': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen Car Play',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        y2e6haahw9vd: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        y6zcqp9r8rfln: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          messages: [
            {
              message: 'Steering Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Steering_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        o0007fa1ki84: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          messages: [
            {
              message: 'Front Bumper',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '9j2b1he3cyuz': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          messages: [
            {
              message: 'SHADER_18in_Alloy_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        zxhw2adigsjb: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Headlamp',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        a39z5tj2p9mu: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Front_Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Front Logo',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '43e5j3wwg3h3': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          messages: [
            {
              message: 'Bed',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        gkyn7z7f6x6e: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Info Screen',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Info Screen Car Play',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        '0lcgclpnp6ew': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          messages: [
            {
              message: 'SHADER_Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            },
            {
              message: 'Speedometer',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        },
        ecjxcwk9ba81: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          messages: [
            {
              message: 'Steering Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: true,
              cascade: false
            },
            {
              message: 'SHADER_Steering_Wheel',
              identifiers: [
                'common_exterior'
              ],
              waitForFulfill: false,
              cascade: false
            }
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {}
        }
      },
      accessories: {
        w9hpmzuxt0zw: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '62L',
              identifiers: [
                'common_exterior',
                'exterior-color',
                'interior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '69tpimc80m8d': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'CHROME_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        u20m3d5j71vd: {
          view: 'exterior',
          groupId: 'high-country-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0agqewqxtxza': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '62L',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOD_LOGO',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3nc1olw2alfg': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_REDLINE_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [
            {
              id: 'vsr3vozntdek',
              autoRemove: false
            }
          ],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vsr3vozntdek: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SPOTTER_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        b6tg7mm7ujey: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'CARPET_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        j173afsvfoxm: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        shr9jmwd4mm7: {
          view: 'exterior',
          groupId: 'high-country-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_POWER',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8hjk03msw523': {
          view: 'exterior',
          groupId: 'high-country-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            e33wj494id3s: {
              add: false,
              snapToLastFrame: true
            }
          },
          affectedInteractionOnRemove: {
            e33wj494id3s: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5ea062y4dxnj': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'HC_Common_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        dto6if7ng76e: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'HC_Variant_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '47fmyjws74cp': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'HC_Variant_Parts_SHORT',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hmlzbxlv36y9: {
          view: 'exterior',
          groupId: 'high-country-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'HIGH_COUNTRY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        h7l2djmpt06c: {
          view: 'exterior',
          groupId: 'high-country-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hi5kmxzzzq9u: {
          view: 'exterior',
          groupId: 'high-country-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0tocr9fb6kax': {
          view: 'exterior',
          groupId: 'high-country-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'AUTO_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        j8kuo5g8mvzt: {
          view: 'exterior',
          groupId: 'high-country-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_AND_CAMERA_IRVM',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rybgoukmmqhe: {
          view: 'exterior',
          groupId: 'high-country-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'POWER_RETRACTABLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            a8jlgfd8evx4: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        drbil9s8a41l: {
          view: 'exterior',
          groupId: 'high-country-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'CHROME_WHEEL_TO_WHEEL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            a8jlgfd8evx4: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mtzheryp1crc: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '54nn9olfhq0x': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jhtdb4dgs4ag: {
          view: 'exterior',
          groupId: 'high-country-g1',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        dhp5omqgvvcg: {
          view: 'exterior',
          groupId: 'high-country-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            a8jlgfd8evx4: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7hbnhyetgkro': {
          view: 'exterior',
          groupId: 'high-country-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Chrome_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            a8jlgfd8evx4: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        uqjfhy5t45zy: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        pdqc9e5ntf2r: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        a6vg80c1um80: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Illuminated_Front_Bowtie_Except_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Illuminated_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Illuminated_Front_Bowtie_Except_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kzb69p4za0o5: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bed Mat_Black',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jw0a0kwm303b: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Hard_Folding_Tonneau_Cover',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lsxhwegkkd4y: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Sports_Bar_Bed_Mounted',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rq9m3rn89rf4: {
          view: 'exterior',
          groupId: 'high-country-g5',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_20in_Machined_Aluminium_HC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_20in_Machined_Aluminium_HC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rq9m3rn89rf904: {
          view: 'exterior',
          groupId: 'high-country-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_20in_High_Gloss_Short_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_20in_High_Gloss_Short_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        dk8i90myygvo: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Midnight Edition HC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {
            e33wj494id3s: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6waediiz4m74': {
          view: 'exterior',
          groupId: 'high-country-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_22in_Painted_Aluminium_HC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_22in_Painted_Aluminium_HC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '876c3pibsjov': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '62L_ZR2_LTTB',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '66huqa03m4o7': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        u3557rhx8d1m: {
          view: 'exterior',
          groupId: 'zr2-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RED_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2qjengswijpp': {
          view: 'exterior',
          groupId: 'zr2-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'BLACK_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jzph1dgkv4md: {
          view: 'exterior',
          groupId: 'zr2-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kb0slo52pbnd: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_REDLINE_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6uxaabsyqpx3': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SPOTTER_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lp03od01mlyo: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'FLOOR_LINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wh68ti5fisga: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ADAPTIVE_CRUISE_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CRUISE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        d45yq1c8nd0s: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        avkty5mam3dk: {
          view: 'exterior',
          groupId: 'zr2-g1',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lrmm67s11zi3: {
          view: 'exterior',
          groupId: 'zr2-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '39rwrhudo7hr': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hu6r3sxwhcqv: {
          view: 'exterior',
          groupId: 'zr2-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        s87repgh8l42: {
          view: 'exterior',
          groupId: 'zr2-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '39rwrhudo7hr': {
              add: false,
              snapToLastFrame: true
            }
          },
          affectedInteractionOnRemove: {
            '39rwrhudo7hr': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5jrmudijeqpm': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ZR2_Common_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zgrj1lgvwg7j: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ZR2_Variant_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        h3gqpm1v53bx: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ZR2_Variant_Parts_SHORT',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '38b1zt9m9l7h': {
          view: 'exterior',
          groupId: 'zr2-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HIGH_COUNTRY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        z4tn2qlwdxdq: {
          view: 'exterior',
          groupId: 'zr2-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        u3zpsiu1n3nb: {
          view: 'exterior',
          groupId: 'zr2-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '29zj0gvuwp98': {
          view: 'exterior',
          groupId: 'zr2-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'AUTO_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '15fp8hgbcwyv': {
          view: 'exterior',
          groupId: 'zr2-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_AND_CAMERA_IRVM',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5bgopnoc8isd': {
          view: 'exterior',
          groupId: 'zr2-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'CHROME_WHEEL_TO_WHEEL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '7p1u0cgedxiz': {
              add: true,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        m27tcb602fql: {
          view: 'exterior',
          groupId: 'zr2-g6',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        h5au9myl063y: {
          view: 'exterior',
          groupId: 'zr2-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tbpzcy915xx3: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qz2iomvtp5mv: {
          view: 'exterior',
          groupId: 'zr2-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        oel878rj2o2x: {
          view: 'exterior',
          groupId: 'zr2-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '7p1u0cgedxiz': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        h5lkbdk5et66: {
          view: 'exterior',
          groupId: 'zr2-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Chrome_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '7p1u0cgedxiz': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        oubehplj30lk: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Pedal Covers',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        c5f6o8lpildp: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8bmp5qdr4umi': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6yep0op98rgw': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Illuminated_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5speucfhfr48': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bed Mat_Black',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4naxdvnyupg8': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Hard_Folding_Tonneau_Cover',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rypmhhonl0tg: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Sports_Bar_Bed_Mounted',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        yy0hy78t9fvl: {
          view: 'exterior',
          groupId: 'zr2-g7',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_18_Aluminium_Machine_Face_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18_Aluminium_Machine_Face_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        n1g3jd1stqd5: {
          view: 'exterior',
          groupId: 'zr2-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_18in_Gloss_Black_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18in_Gloss_Black_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        n1g3jd1stqd905: {
          view: 'exterior',
          groupId: 'zr2-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_18in_High_Gloss_Short_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18in_High_Gloss_Short_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        pyw2gvfy8z9g: {
          view: 'exterior',
          groupId: 'zr2-g8',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STEERING_MANUAL_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        h58thpxpqmpc: {
          view: 'exterior',
          groupId: 'zr2-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_POWER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zh0uvtjvnqfa: {
          view: 'exterior',
          groupId: 'zr2-g9',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        drdn0mg8sb78: {
          view: 'exterior',
          groupId: 'zr2-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        th8zueo3valx: {
          view: 'exterior',
          groupId: 'zr2-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        cdrpwn9dos9r: {
          view: 'exterior',
          groupId: 'zr2-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_POWER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        aww7oooc9won: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Dark Appearance ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '39rwrhudo7hr': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2bo0gswfrfcz': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_20in_High_Gloss_Short_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_20in_High_Gloss_Short_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        c6u4n5p3dp39: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'W_FOG_W_VENT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FOG',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zl5dd3sw2bt1: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g1',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'DURAMAX_ZR2_LTTB',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3jyopz3oorhe': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g1',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'TURBOMAX_ZR2_LTTB',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jnybh05tlkfs: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RED_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        u02qdok8qgoi: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'BLACK_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        oz0z7dsfp8bd: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        m03wg71zplza: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        un7e58s023em: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_REDLINE_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mli9be6yh6pr: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SPOTTER_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0pk9phb573rt': {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'FLOOR_LINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [
            {
              id: 'j2wfqejl5fxk',
              autoRemove: false
            }
          ],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9l7a7vvp5buq': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ADAPTIVE_CRUISE_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CRUISE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2ybsfpcpw041': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        j2wfqejl5fxk: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            bjq73d6ex5uw: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        sn2lalj1ic7j: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g5',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '34z00lryq9uk': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            bjq73d6ex5uw: {
              add: false,
              snapToLastFrame: true
            }
          },
          affectedInteractionOnRemove: {
            bjq73d6ex5uw: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        i2m85llrw0bu: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'TrailBoss_Common_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7gsoxqirzwj4': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'TrailBoss_Variant_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hbv59yodwomm: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'TrailBoss_Variant_Parts_SHORT',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6kmb8jxn2g9t': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HIGH_COUNTRY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ltmgrevl229k: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        yjbw6quzffew: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '37nnp2r86h97': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tg93h5y76f2f: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_AND_CAMERA_IRVM',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        akfa3p311thw: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'CHROME_WHEEL_TO_WHEEL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '8dvmfe5qick4': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        s2lulhvnbsid: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5coix9shmd1o': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g9',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        v2ej8yk6v14e: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        t128kzfbtn1f: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        oxiuvot0twab: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g8',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '8dvmfe5qick4': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        j8ufoo4scfer: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Chrome_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '8dvmfe5qick4': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xaqcampnqq5z: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Pedal Covers',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9nvo6s76ajus': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '38k3iyysbq2z': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fd6bpuickxcp: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Illuminated_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        n530gwunez4g: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bed Mat_Black',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '735wgq63ug0k': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Hard_Folding_Tonneau_Cover',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lp5918siuusp: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Sports_Bar_Bed_Mounted',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        o1czcsnfg64j: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_18in_High_Gloss_Short_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18in_High_Gloss_Short_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '603xlrj84z06': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_MANUAL_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0mdferymt8kz': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_POWER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3gcejyte0k2w': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ivmhdr8aj6iv: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        npsyote0o3kj: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        c1l34m40cnhz: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_POWER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '73ymcufp080z': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_W_Camera',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_CAMERA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ont3on5c7qax: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g13',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5341) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'WO_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5346) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        e84uvam0sehp: {
          view: 'interior',
          groupId: 'trail-boss-crew-cab-g13',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5341) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'W_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5346) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3g4a6gwcxysh': {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'DOOR_BOSE_SPEAKER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DOOR_SPEAKER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        r8ypn17xe1ao: {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g14',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BENCH_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5341) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'BENCH_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5346) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        la6n9w1lw34y: {
          view: 'interior',
          groupId: 'trail-boss-crew-cab-g14',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'BUCKET_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5341) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'BUCKET_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5346) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '37vy4x17zma1': {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'HEATED_STEERING_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qzroidq5dh2h: {
          view: 'interior',
          groupId: 'trail-boss-crew-cab-g15',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'PILLAR_WO_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5341) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'PILLAR_WO_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5346) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6zvsql40dfeu': {
          view: 'exterior',
          groupId: 'trail-boss-crew-cab-g15',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'PILLAR_W_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5341) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'PILLAR_W_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5346) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [
            {
              id: 'la6n9w1lw34y',
              autoRemove: false
            }
          ],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        r1of6om2fww7: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_SINGLE_EXHAUST_TB',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4ai8by09rqvh': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_DUAL_EXHAUST_TB',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8fipb3d7mw06': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Midnight Edition LTTB CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {
            bjq73d6ex5uw: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ey2n7o70uqp2: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Dark Appearance LTTB CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {
            bjq73d6ex5uw: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        e38raezqc0yr: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8bavf3nhxttl': {
          view: 'exterior',
          groupId: 'trail-boss-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_20in_High_Gloss_Std_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_20in_High_Gloss_Std_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rshtgcsxc87m: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'W_FOG_W_VENT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FOG',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jik37nn77ze2: {
          view: 'exterior',
          groupId: 'trail-boss-g1',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'DURAMAX_ZR2_LTTB',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        i7nci40itn8y: {
          view: 'exterior',
          groupId: 'trail-boss-g1',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'TURBOMAX_ZR2_LTTB',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        gp1ercwlphfc: {
          view: 'exterior',
          groupId: 'trail-boss-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RED_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        a3rwg17sz7f3: {
          view: 'exterior',
          groupId: 'trail-boss-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'BLACK_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9b6tnvf421wy': {
          view: 'exterior',
          groupId: 'trail-boss-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1bfrm3gx9mcw': {
          view: 'exterior',
          groupId: 'trail-boss-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wx09nefcniov: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_REDLINE_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8whocyzz2mpv': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SPOTTER_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        khdpkk7yyjzb: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'FLOOR_LINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zu3ppcoocclt: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ADAPTIVE_CRUISE_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CRUISE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        by9grbxo4aoa: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4vobyj2julb1': {
          view: 'exterior',
          groupId: 'trail-boss-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jrk76pk085do: {
          view: 'exterior',
          groupId: 'trail-boss-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '4igcs67fpy6q': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mozank45tss3: {
          view: 'exterior',
          groupId: 'trail-boss-g5',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qlekkubrc753: {
          view: 'exterior',
          groupId: 'trail-boss-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '4igcs67fpy6q': {
              add: false,
              snapToLastFrame: true
            }
          },
          affectedInteractionOnRemove: {
            '4igcs67fpy6q': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        beuarz4vde0x: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'TrailBoss_Common_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zyg1ajt1tt55: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'TrailBoss_Variant_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0pphlhk9sfsc': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'TrailBoss_RC',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'TrailBoss_Variant_Parts_STDBED',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        voqklcsa3nah: {
          view: 'exterior',
          groupId: 'trail-boss-g2',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HIGH_COUNTRY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        altpyb8zy1ho: {
          view: 'exterior',
          groupId: 'trail-boss-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        nzp13ofwquhk: {
          view: 'exterior',
          groupId: 'trail-boss-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        p9fafesml8k3: {
          view: 'exterior',
          groupId: 'trail-boss-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vopa9h4ufomx: {
          view: 'exterior',
          groupId: 'trail-boss-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_AND_CAMERA_IRVM',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hf6hrn5vorm4: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'CHROME_WHEEL_TO_WHEEL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            m34u55h0srjx: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '971lnvws25bw': {
          view: 'exterior',
          groupId: 'trail-boss-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        z3atoyjjx1j4: {
          view: 'exterior',
          groupId: 'trail-boss-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lxmkprqdxs62: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '87ge77v9ftll': {
          view: 'exterior',
          groupId: 'trail-boss-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mcpnwyf7lsx6: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Pedal Covers',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vv66hhabuo0n: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bk2f45i70lk6: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '89kafvbu8vki': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Illuminated_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ubiyf8t53qzl: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bed Mat_Black_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bed Mat_Black',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bed Mat_Black_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5bs0mlsj81xs': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Hard_Folding_Tonneau_Cover_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Hard_Folding_Tonneau_Cover',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Hard_Folding_Tonneau_Cover_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ojnsp9mlwvqf: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Sports_Bar_Bed_Mounted_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Sports_Bar_Bed_Mounted',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Sports_Bar_Bed_Mounted_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bch105mtur44: {
          view: 'exterior',
          groupId: 'trail-boss-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_18in_High_Gloss_Std_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18in_High_Gloss_Std_bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vaffg14y2l1w: {
          view: 'exterior',
          groupId: 'trail-boss-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_MANUAL_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        roiy440sk7wq: {
          view: 'exterior',
          groupId: 'trail-boss-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_POWER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        f78w22e8lpmg: {
          view: 'exterior',
          groupId: 'trail-boss-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wuybyhmuok0k: {
          view: 'exterior',
          groupId: 'trail-boss-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5a0xpsxa6ued': {
          view: 'exterior',
          groupId: 'trail-boss-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jsgv4y4249i6: {
          view: 'exterior',
          groupId: 'trail-boss-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_POWER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        iybopfjxc5pa: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_W_Camera',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_CAMERA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7kvasj28jy0s': {
          view: 'exterior',
          groupId: 'trail-boss-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5536) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'WO_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5535) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1nyebxioseb0': {
          view: 'interior',
          groupId: 'trail-boss-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5536) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'W_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5535) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hvo5pzp4rqz3: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'DOOR_BOSE_SPEAKER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DOOR_SPEAKER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        gaz4jpsceins: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'BENCH_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5536) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'BENCH_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5535) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1kl47g2ws5um': {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BUCKET_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5536) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'BUCKET_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5535) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        q8lzyk3t6ge3: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HEATED_STEERING_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '42g6mrn15b5v': {
          view: 'exterior',
          groupId: 'trail-boss-g13',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'PILLAR_WO_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5536) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'PILLAR_WO_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5535) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0l48xpuwzt8e': {
          view: 'exterior',
          groupId: 'trail-boss-g13',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'PILLAR_W_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5536) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'PILLAR_W_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5535) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        t0erixwko2g6: {
          view: 'exterior',
          groupId: 'trail-boss-g14',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_SINGLE_EXHAUST_TB',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        r6ihv55m085t: {
          view: 'exterior',
          groupId: 'trail-boss-g14',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DUAL_EXHAUST_TB',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9v54hle0okz0': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Midnight Edition LTTB RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '4igcs67fpy6q': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zmvz8kuaprfi: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Dark Appearance LTTB RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '4igcs67fpy6q': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        enwcx26f9mkk: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_20in_Painted_Aluminium_Short_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_20in_Painted_Aluminium_Short_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        aamcmr19ejqi: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'W_FOG_WO_VENT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        pq8zmgmxh0v2: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g1',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kdclty1lv6yc: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'TURBOMAX',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        x16xwfsr429z: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        brt3rx24ctz0: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'RED_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        j9vm0h8qens0: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BLACK_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        gxg2jtly723c: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ORVM_WO_Camera',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_CAMERA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vp09insg1mki: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_REDLINE_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        c9nv2bfy9uu1: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SPOTTER_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        khw0krkakszm: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RUBBER_FRONT_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'RUBBER_REAR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fuwls9gkrtq0: {
          view: 'interior',
          groupId: 'rst-crew-cab-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'FLOOR_LINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [
            {
              id: '225r2u3835jz',
              autoRemove: false
            }
          ],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        y6ntqxq1phyg: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ADAPTIVE_CRUISE_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CRUISE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        v0uslhm8fb90: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '24yy1luzf7j1': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '225r2u3835jz': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            vlasgxry3r2e: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5qpvguu2ist8': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g4',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8q49bxzncwev': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g4',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            vlasgxry3r2e: {
              add: false,
              snapToLastFrame: true
            }
          },
          affectedInteractionOnRemove: {
            vlasgxry3r2e: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lrv58ij88fde: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '75bhbffo339e': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RST_Variant_Parts_SHORT',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lsibu5dpt59e: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'LT_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1qbbxch49uhf': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HIGH_COUNTRY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ya6bffpuyjqh: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        z2irqtn1o9vl: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zsgsdtatb4ye: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7nfhymbny0tf': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_AND_CAMERA_IRVM',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '33wdst9gysz5': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g7',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'CHROME_WHEEL_TO_WHEEL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            sk4ftvul6hgw: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hyvbd9wmcrgv: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g8',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ec5gv425ndy7: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3kdfoa2ch3dg': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jt57wm53sz8l: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        snvlft6p6hur: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        htnp53ovjc9a: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        dvl30nnebrlo: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6b0wxy093zjp': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g7',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            sk4ftvul6hgw: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kzm1rcqbiw5g: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Chrome_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            sk4ftvul6hgw: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        yam3kafate2u: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Pedal Covers',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        b5ivj0y9s8sf: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hc5h7z7u47nk: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        v45l2f9h5anp: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Illuminated_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        nd4551bx7a8i: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bed Mat_Black',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0lzqlzooomyq': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Hard_Folding_Tonneau_Cover',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6vrysp727zx0': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Sports_Bar_Bed_Mounted',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        flcdriu7beaw: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_18in_Bright_Silver_Short_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18in_Bright_Silver_Short_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wihl6kprivy0: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_MANUAL_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        g2m4yrmyyynz: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_POWER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bjxt08ns4nof: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hyk5vwlktq1x: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        dpt33m49akus: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g13',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        n94fzze0tvrt: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g13',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_POWER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '21zwbuxlcavw': {
          view: 'interior',
          groupId: 'rst-crew-cab-g14',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5337) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'WO_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5345) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rvpnnu0k326r: {
          view: 'interior',
          groupId: 'rst-crew-cab-g14',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5337) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'W_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5345) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hc2waknpvkej: {
          view: 'interior',
          groupId: 'rst-crew-cab-g15',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'BUCKET_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5337) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'BUCKET_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5345) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        n7dz0snnwmvo: {
          view: 'interior',
          groupId: 'rst-crew-cab-g15',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BENCH_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5337) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'BENCH_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5345) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        spmqj5ulgz86: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'HEATED_STEERING_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3ggimjowfl66': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g16',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'PILLAR_WO_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5337) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'PILLAR_WO_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5345) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [
            {
              id: 'hc2waknpvkej',
              autoRemove: false
            }
          ],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5dferxjng8my': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g16',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'PILLAR_W_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5337) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'PILLAR_W_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5345) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [
            {
              id: 'hc2waknpvkej',
              autoRemove: false
            }
          ],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bo65zmllt1ve: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g17',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SILVERADO',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mzckwh973o1y: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g17',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '11okflqv5eq9': {
          view: 'interior',
          groupId: 'rst-crew-cab-g18',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6xej21dk4z8n': {
          view: 'interior',
          groupId: 'rst-crew-cab-g18',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2gu367fy93cp': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g19',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '4WD_SINGLE_SPEED',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        l0mv3qhmi42a: {
          view: 'interior',
          groupId: 'rst-crew-cab-g19',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '4WD_TWO_SPEED',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        owknxlwm8qx1: {
          view: 'exterior',
          groupId: 'rst-crew-cab-g20',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_SINGLE_EXHAUST_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2qvaqumopcbw': {
          view: 'exterior',
          groupId: 'rst-crew-cab-g20',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DUAL_EXHAUST_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '46y6qv6omn9t': {
          view: 'exterior',
          groupId: 'rst-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_20in_Painted_Aluminium_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_20in_Painted_Aluminium_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        l2uioho3tg37: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'W_FOG_WO_VENT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1qrv7uy2hn4u': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'DURAMAX',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kw2owicdikzj: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '500b9sjr98qp': {
          view: 'exterior',
          groupId: 'rst-g1',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'RED_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1pl1livfn0m3': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BLACK_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fqfe8415hbb4: {
          view: 'exterior',
          groupId: 'rst-g1',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'BLACK_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mn5mv4w5ovv1: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ORVM_WO_Camera',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_CAMERA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ezjt7jvfmb01: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_REDLINE_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        e9tntv7n8acw: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SPOTTER_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        y7eynwbblyjx: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RUBBER_FRONT_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4ri84tlxzf3i': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ADAPTIVE_CRUISE_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CRUISE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ty7d3to02069: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        woxdn43eic08: {
          view: 'exterior',
          groupId: 'rst-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        s73hn6clquce: {
          view: 'exterior',
          groupId: 'rst-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            zywf2eknfbem: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2qgxzrzd98b7': {
          view: 'exterior',
          groupId: 'rst-g3',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lz8d2rq8l78n: {
          view: 'exterior',
          groupId: 'rst-g3',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            zywf2eknfbem: {
              add: false,
              snapToLastFrame: true
            }
          },
          affectedInteractionOnRemove: {
            zywf2eknfbem: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8u1n69n7f3tr': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '94lak34bsaum': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_RST_RC',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2qh2y5dzlam2': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RST_Variant_Parts_STDBED',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0mbo5g146xof': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'RST_RC',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        i7ghu3y0onx1: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HIGH_COUNTRY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        nzc2kkcjvxeg: {
          view: 'exterior',
          groupId: 'rst-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zcxfm0t5hiiy: {
          view: 'exterior',
          groupId: 'rst-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5kjnxltj8pbo': {
          view: 'exterior',
          groupId: 'rst-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3njxugdgv4k3': {
          view: 'exterior',
          groupId: 'rst-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_AND_CAMERA_IRVM',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        r8usax6b64p7: {
          view: 'exterior',
          groupId: 'rst-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'CHROME_WHEEL_TO_WHEEL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            ekb9gx2zypw8: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9iia2nsc033z': {
          view: 'exterior',
          groupId: 'rst-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        yjx2x1bvum9k: {
          view: 'exterior',
          groupId: 'rst-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vjgwyj3p4805: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ozh8tlqamko3: {
          view: 'exterior',
          groupId: 'rst-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        nc672x9l24tp: {
          view: 'exterior',
          groupId: 'rst-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3t7rttr6bx2z': {
          view: 'exterior',
          groupId: 'rst-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        b9dfy0g7ik1m: {
          view: 'exterior',
          groupId: 'rst-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bfbuwrrfiao3: {
          view: 'exterior',
          groupId: 'rst-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            ekb9gx2zypw8: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bxgkx6bmaw4a: {
          view: 'exterior',
          groupId: 'rst-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Chrome_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            ekb9gx2zypw8: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6y0f764end5z': {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Pedal Covers',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wwfk2839r7od: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ipdv50xde60b: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1kio6fr3sbmv': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Illuminated_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xyt93f3ss4h8: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bed Mat_Black_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bed Mat_Black',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bed Mat_Black_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '5i7159u1mhw3': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Hard_Folding_Tonneau_Cover_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Hard_Folding_Tonneau_Cover',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Hard_Folding_Tonneau_Cover_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rmpop006w5i0: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Sports_Bar_Bed_Mounted_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Sports_Bar_Bed_Mounted',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Sports_Bar_Bed_Mounted_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        szwkjiq1besx: {
          view: 'exterior',
          groupId: 'rst-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_18in_Bright_Silver_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18in_Bright_Silver_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        s8cxrszuo348: {
          view: 'exterior',
          groupId: 'rst-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_MANUAL_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5534) is (interior-color)',
              isDefault: true,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7jy59inwr81c': {
          view: 'exterior',
          groupId: 'rst-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_POWER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        icxa4nro7vby: {
          view: 'exterior',
          groupId: 'rst-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vhux4rln8ytz: {
          view: 'exterior',
          groupId: 'rst-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rt9elr84l8kj: {
          view: 'exterior',
          groupId: 'rst-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        lq0wkwzd2nbv: {
          view: 'exterior',
          groupId: 'rst-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_POWER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        aet80k88ue5a: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5534) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'WO_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5537) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '39f8mfcupfp4': {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BUCKET_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5534) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'BUCKET_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5537) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wwbecwxqv2md: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'HEATED_STEERING_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        pqedc214n44x: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'PILLAR_WO_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5534) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'PILLAR_WO_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5537) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        t1xwoo934ln6: {
          view: 'exterior',
          groupId: 'rst-g13',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SILVERADO',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '69b99z5t9il4': {
          view: 'exterior',
          groupId: 'rst-g13',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        l34j8pmcdqzg: {
          view: 'interior',
          groupId: 'rst-g14',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wtyvo38z3fe1: {
          view: 'interior',
          groupId: 'rst-g14',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kt1s36efscg4: {
          view: 'interior',
          groupId: 'rst-g15',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '4WD_SINGLE_SPEED',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vwiga2uaok0o: {
          view: 'interior',
          groupId: 'rst-g15',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '4WD_TWO_SPEED',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        y0bo6qow8ci9: {
          view: 'exterior',
          groupId: 'rst-g16',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_SINGLE_EXHAUST_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7nvudf5dm6vl': {
          view: 'exterior',
          groupId: 'rst-g16',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DUAL_EXHAUST_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        aj24okukxiy1: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_20in_Painted_Aluminium_Short_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_20in_Painted_Aluminium_Short_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wzz8zk92pz7y: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_FOG_W_VENTS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zbss582phyw0: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'TURBOMAX',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7yg1c0lftxiq': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zzf69gky2znz: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'RED_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qbgpy7iuqies: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BLACK_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tadkb0ery03z: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ORVM_W_Camera',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_CAMERA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8dng36kha4c1': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_REDLINE_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rk8q3jqbjbox: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SPOTTER_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        olgrvm8pgxh4: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RUBBER_FRONT_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ruel9xhclpcx: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ADAPTIVE_CRUISE_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CRUISE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        prwoau4fn32x: {
          view: 'interior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        eu5v4taho21m: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        d3efjusxmmgq: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            gdp46rwbpnl4: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ecl9pgc6k8oj: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '098o326v3gqp': {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'SHORT_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(SHORT_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            gdp46rwbpnl4: {
              add: false,
              snapToLastFrame: true
            }
          },
          affectedInteractionOnRemove: {
            gdp46rwbpnl4: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7aiecrltj7tk': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_Common_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mu9y84dv1tic: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_Variant_Parts_SHORT',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '33wdpgx4u2xg': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '68fzloqy2pln': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HIGH_COUNTRY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jko5gfx33c1q: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0ugj03jtis6p': {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '528qxx1fs3ch': {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vyyz49o1fuco: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_AND_CAMERA_IRVM',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wd1bgstn1jih: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'CHROME_WHEEL_TO_WHEEL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '80v66cmn04mn': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        j88iwbncrgrf: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tploudv07w4z: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        yp9y0hi01wg6: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        smygy8byvbp1: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '53np0q7rtn46': {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fp1wk36t4i6h: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        o70k784u3bzq: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        e66zxhb8mc6h: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g5',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '80v66cmn04mn': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        aq4ttf5pw2tx: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Chrome_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            '80v66cmn04mn': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        uyslmwyjroc2: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Pedal Covers',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zgf4ep9h0dln: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7swuj7dak6hy': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rwpz5ie6e62k: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Illuminated_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        h6pbcv9f8t1n: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bed Mat_Black',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bed Mat_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0p6lt9cbjp4m': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Hard_Folding_Tonneau_Cover',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Hard_Folding_Tonneau_Cover_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3g0ubv7q5d0s': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Sports_Bar_Bed_Mounted',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Sports_Bar_Bed_Mounted_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        w9w3fgevl9ih: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_18in_Bright_Silver_Short_Bed_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18in_Bright_Silver_Short_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        o3tzyrq63mdk: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_MANUAL_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xv3t34gxllpn: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_POWER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '31vuqrwv8fpy': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        i3ccwie2wugj: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rm81gaacdptt: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_POWER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bw1tbpr57px1: {
          view: 'interior',
          groupId: 'lt-crew-cab-4wd-g10',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5338) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'WO_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5343) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        o74dtmfoe14w: {
          view: 'interior',
          groupId: 'lt-crew-cab-4wd-g10',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [
              '1z0i3csgxouu'
            ],
            exterior: []
          }
        },
        mmt5fkupfwgm: {
          view: 'interior',
          groupId: 'lt-crew-cab-4wd-g11',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'BUCKET_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5338) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'BUCKET_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5343) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        yi923erhdqki: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g11',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BENCH_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5338) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'BENCH_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5343) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        dmav4tpowddq: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HEATED_STEERING_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6zeu4yky77ch': {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g12',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'PILLAR_WO_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5338) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'PILLAR_WO_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5343) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9wfw66rgxn7x': {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'PILLAR_W_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5338) is (interior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'PILLAR_W_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '(5343) is (interior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [
            {
              id: 'mmt5fkupfwgm',
              autoRemove: false
            }
          ],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7x9zcgeppbrn': {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g13',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SILVERADO',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        h9cjgpp9xv7e: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g13',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1gb7vhwjppqi': {
          view: 'interior',
          groupId: 'lt-crew-cab-4wd-g14',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        n58nvecii5t2: {
          view: 'interior',
          groupId: 'lt-crew-cab-4wd-g14',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2gvshcyn14y2': {
          view: 'interior',
          groupId: 'lt-crew-cab-4wd-g15',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '4WD_SINGLE_SPEED',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'RWD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9p8hhjnpsfhp': {
          view: 'interior',
          groupId: 'lt-crew-cab-4wd-g15',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '4WD_TWO_SPEED',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        u5wbwvw4lwyb: {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g16',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SHORT_SINGLE_EXHAUST_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7k8pshah93ij': {
          view: 'exterior',
          groupId: 'lt-crew-cab-4wd-g16',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_DUAL_EXHAUST_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ppwzigedaacf: {
          view: 'exterior',
          groupId: 'lt-4wd-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_20in_Painted_Aluminium_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_20in_Painted_Aluminium_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ikq01lpmnxig: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_FOG_WO_VENTS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4l2ch5gt1jei': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'DURAMAX',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        u13ejr7mha46: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        w8m6jkrjpf1n: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'RED_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qflhjgii0zs4: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BLACK_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tldc3lal50a5: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ORVM_WO_Camera',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_CAMERA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qh35c8m63fni: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_REDLINE_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        m8lvefhp9cjj: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SPOTTER_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        roemf657c1p9: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RUBBER_FRONT_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qxnhtszm5ndk: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ADAPTIVE_CRUISE_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CRUISE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zzq11yb2fvlz: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0r0maueg9zyo': {
          view: 'exterior',
          groupId: 'lt-4wd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9sfws9yqkuc3': {
          view: 'exterior',
          groupId: 'lt-4wd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '7zuqcg1sjgzs': {
          view: 'exterior',
          groupId: 'lt-4wd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1e4rnxy0qlis': {
          view: 'exterior',
          groupId: 'lt-4wd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            }
          },
          affectedInteractionOnRemove: {
            '9a4ewd0iqpwk': {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jo4o2zby05cf: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_Common_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '08hmxlpd4m8f': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_RST_RC',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '03hkpg6h1hkc': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_Variant_Parts_STDBED',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        a8cqkrto3nke: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HIGH_COUNTRY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        csmney59ys4x: {
          view: 'exterior',
          groupId: 'lt-4wd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        d4exwpm90nts: {
          view: 'exterior',
          groupId: 'lt-4wd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fpg8rp26eee3: {
          view: 'exterior',
          groupId: 'lt-4wd-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mpmwposb1tye: {
          view: 'exterior',
          groupId: 'lt-4wd-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_AND_CAMERA_IRVM',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2ywwchobf7f5': {
          view: 'exterior',
          groupId: 'lt-4wd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'CHROME_WHEEL_TO_WHEEL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ma8rbv12vcwb: {
          view: 'exterior',
          groupId: 'lt-4wd-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8htt9z21rexy': {
          view: 'exterior',
          groupId: 'lt-4wd-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ty4mln8g58kr: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vvt74t57t45w: {
          view: 'exterior',
          groupId: 'lt-4wd-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        x6op3smx7n02: {
          view: 'exterior',
          groupId: 'lt-4wd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vxwve40pucxw: {
          view: 'exterior',
          groupId: 'lt-4wd-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        sumurt3l7hh7: {
          view: 'exterior',
          groupId: 'lt-4wd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8i0esom5o4ks': {
          view: 'exterior',
          groupId: 'lt-4wd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Black_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        z5r3van9yglu: {
          view: 'exterior',
          groupId: 'lt-4wd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Chrome_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            xbdzchklx04d: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        b0ncvdhudq5p: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Pedal Covers',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        piwvb7c4q251: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        i02sca1ic9ai: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9e4mhz7b5v47': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Illuminated_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wmexvu2t7sgn: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bed Mat_Black_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bed Mat_Black',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bed Mat_Black_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xsi63vni3i4w: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Hard_Folding_Tonneau_Cover_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Hard_Folding_Tonneau_Cover',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Hard_Folding_Tonneau_Cover_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        e2ng81orh764: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Sports_Bar_Bed_Mounted_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Sports_Bar_Bed_Mounted',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Sports_Bar_Bed_Mounted_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xqb4ho3sx176: {
          view: 'exterior',
          groupId: 'lt-4wd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_18in_Bright_Silver_Std_Bed_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18in_Bright_Silver_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4bt1ywim06o7': {
          view: 'exterior',
          groupId: 'lt-4wd-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_MANUAL_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        n7xm4bdk03yy: {
          view: 'exterior',
          groupId: 'lt-4wd-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_POWER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        b16sm4roet5l: {
          view: 'exterior',
          groupId: 'lt-4wd-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        emd69mkez0yx: {
          view: 'exterior',
          groupId: 'lt-4wd-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        cvfp1430s1is: {
          view: 'exterior',
          groupId: 'lt-4wd-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ipxrgvwp54iq: {
          view: 'exterior',
          groupId: 'lt-4wd-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_POWER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0k97mfhk07bk': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'WO_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hurcnmxhohxu: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'BUCKET_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'BUCKET_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '84bjgtdelash': {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BENCH_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0xpp8n3v94pe': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HEATED_STEERING_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wclr4whopkwn: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'PILLAR_WO_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'PILLAR_WO_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        j2rynhdwnwk0: {
          view: 'exterior',
          groupId: 'lt-4wd-g12',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SILVERADO',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0w8gce7si79p': {
          view: 'exterior',
          groupId: 'lt-4wd-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ai8r4op2zjgy: {
          view: 'exterior',
          groupId: 'lt-4wd-g13',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '4hj05h5lb75y': {
          view: 'interior',
          groupId: 'lt-4wd-g13',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        jt71de53b4iz: {
          view: 'exterior',
          groupId: 'lt-4wd-g14',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: '4WD_SINGLE_SPEED',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        edt07rmrzik9: {
          view: 'interior',
          groupId: 'lt-4wd-g14',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '4WD_TWO_SPEED',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ai7m6an2ha1o: {
          view: 'exterior',
          groupId: 'lt-4wd-g15',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_SINGLE_EXHAUST_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '0ln8s93srv7z': {
          view: 'exterior',
          groupId: 'lt-4wd-g15',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DUAL_EXHAUST_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ho29v2z419zo: {
          view: 'exterior',
          groupId: 'lt-rwd-g0',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Alloy_20in_Painted_Aluminium_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_20in_Painted_Aluminium_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        w7cg8b79m7pz: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_FOG_WO_VENTS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        z1t3kt43hg14: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'DURAMAX',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        symi0bnl8ndg: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tzs5k4rso8bg: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'RED_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '28vqgmus9n1x': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BLACK_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HOOK',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        di75vldkd36j: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'ORVM_WO_Camera',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_CAMERA',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qwmzyw8beg99: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ORVM_REDLINE_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_DECAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [
            {
              id: 'apnydor0mu4w',
              autoRemove: false
            }
          ],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        apnydor0mu4w: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SPOTTER_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ORVM_MIRROR',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8a3qrlzcwi5d': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RUBBER_FRONT_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FLOOR_MAT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ngkcd58rhw6h: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ADAPTIVE_CRUISE_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CRUISE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2budg42ejesq': {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HITCH_VIEW',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        qi6iu757kmgy: {
          view: 'exterior',
          groupId: 'lt-rwd-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: true,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        maodhxzlje1a: {
          view: 'exterior',
          groupId: 'lt-rwd-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            y06f4jy4mex5: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        pxxb7o4i00rd: {
          view: 'exterior',
          groupId: 'lt-rwd-g2',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_MULTI_FLEX_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '9budfczm63vf': {
          view: 'exterior',
          groupId: 'lt-rwd-g2',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_WO_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'exterior-color'
              ],
              condition: '(STD_DEFAULT_W_BEDLINER) in accessories of (exterior-color)',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            y06f4jy4mex5: {
              add: false,
              snapToLastFrame: true
            }
          },
          affectedInteractionOnRemove: {
            y06f4jy4mex5: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        b73gxc5vzydw: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_Common_Parts',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        j2u21hp1iq3m: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_RST_RC',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        s86l6qxejbu3: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_Variant_Parts_STDBED_RWD',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '723dflxfu4h4': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HIGH_COUNTRY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        s0w2vauwxkzc: {
          view: 'exterior',
          groupId: 'lt-rwd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mtfze63vc2hh: {
          view: 'exterior',
          groupId: 'lt-rwd-g3',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_HUD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        tziink3u85l9: {
          view: 'exterior',
          groupId: 'lt-rwd-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ht34v61wtf55: {
          view: 'exterior',
          groupId: 'lt-rwd-g4',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'AUTO_AND_CAMERA_IRVM',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_IRVM',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '622lixmwsekz': {
          view: 'exterior',
          groupId: 'lt-rwd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'CHROME_WHEEL_TO_WHEEL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ASSIST_STEPS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {
            me1n6qt2sdto: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ntizrbsmh1gb: {
          view: 'exterior',
          groupId: 'lt-rwd-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_1',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        xhqfq9g8b8ry: {
          view: 'exterior',
          groupId: 'lt-rwd-g6',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ylarduisiw6g: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ROOF_LIGHT_3',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF_LIGHT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kp4guhh2w0rf: {
          view: 'exterior',
          groupId: 'lt-rwd-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '2tdpg3de5tw5': {
          view: 'exterior',
          groupId: 'lt-rwd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DEFAULT_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'STD_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '3gtxmwncg3li': {
          view: 'exterior',
          groupId: 'lt-rwd-g7',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_WO_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        j3w8rwxjuhs9: {
          view: 'exterior',
          groupId: 'lt-rwd-g8',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_MULTI_FLEX_W_BEDLINER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ftzwe1jn4e4i: {
          view: 'exterior',
          groupId: 'lt-rwd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Black_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            me1n6qt2sdto: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        inq0pozyllrv: {
          view: 'exterior',
          groupId: 'lt-rwd-g5',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Assist_Steps_Chrome_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Assist_Steps',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {
            me1n6qt2sdto: {
              add: false,
              snapToLastFrame: true
            }
          },
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        rfqovmmh3alm: {
          view: 'interior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Pedal Covers',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Pedal Covers_Sport_Stainless_Steel',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        g0b9grs14rhs: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Logo_Puddle_Light',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8hq3v6l0hkm3': {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bowtie_Graphic_CC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bowtie_Graphic_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mzu41xcr9a36: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Illuminated_Front_Bowtie',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Illuminated_Front_Bowtie_ZR2',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        kvuebey0uhz5: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Bed Mat_Black_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Bed Mat_Black',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Bed Mat_Black_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        zqbevqp2jr1l: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Hard_Folding_Tonneau_Cover_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Hard_Folding_Tonneau_Cover',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Hard_Folding_Tonneau_Cover_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        hegqbt2xqlo8: {
          view: 'exterior',
          groupId: '',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'ACC_Sports_Bar_Bed_Mounted_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'Camera_Sports_Bar_Bed_Mounted',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_Sports_Bar_Bed_Mounted_RC',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '8b23t59k57j1': {
          view: 'exterior',
          groupId: 'lt-rwd-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Alloy_18in_Bright_Silver_Std_Bed_LT',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ALLOY',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [
            {
              message: 'Shader_18in_Bright_Silver_Std_Bed',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        or5gwme29v7n: {
          view: 'exterior',
          groupId: 'lt-rwd-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_MANUAL_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        bp09rms79955: {
          view: 'exterior',
          groupId: 'lt-rwd-g9',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STEERING_POWER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STEERING',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        vbx75pxycfex: {
          view: 'exterior',
          groupId: 'lt-rwd-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        p6rrhwl4i2ml: {
          view: 'exterior',
          groupId: 'lt-rwd-g10',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_TASK_LAMP',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '1obrn72vzijr': {
          view: 'exterior',
          groupId: 'lt-rwd-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_MANUAL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        iytido69x6ut: {
          view: 'exterior',
          groupId: 'lt-rwd-g11',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'SHORT_TAILGATE_POWER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SHORT_TAILGATE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        wt5lpfvsfo72: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'WO_STORAGE_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'WO_STORAGE_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_REAR_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        gzdwn4sibgmf: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'BUCKET_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'BUCKET_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        w85x6ywvjrg0: {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'BENCH_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_CONSOLE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '6kdz9iccj0ao': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'HEATED_STEERING_SEATS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '18ahvekaj1v4': {
          view: 'exterior',
          groupId: '',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'PILLAR_WO_SPEAKER_CLOTH',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            },
            {
              message: 'PILLAR_WO_SPEAKER_LEATHER',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ba02cdvd1o3m: {
          view: 'exterior',
          groupId: 'lt-rwd-g12',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'SILVERADO',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        '98e9rbbpf68a': {
          view: 'exterior',
          groupId: 'lt-rwd-g12',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'Z71',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_FENDER_BADGE',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        fkdw5mju9dcs: {
          view: 'interior',
          groupId: 'lt-rwd-g13',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        cm47z7tb0x2p: {
          view: 'interior',
          groupId: 'lt-rwd-g13',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_HILL_CONTROL',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_DASH_CONTROLS',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        mn5hw8cgflef: {
          view: 'interior',
          groupId: 'lt-rwd-g14',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'RWD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        ikgkl3ydphv6: {
          view: 'interior',
          groupId: 'lt-rwd-g14',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: '4WD_TWO_SPEED',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_4WD',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        cm1unghtwzn0: {
          view: 'exterior',
          groupId: 'lt-rwd-g15',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'STD_SINGLE_EXHAUST_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        },
        gijf0jl9aj8m: {
          view: 'exterior',
          groupId: 'lt-rwd-g15',
          display: false,
          isDefault: false,
          applyMessages: [
            {
              message: 'STD_DUAL_EXHAUST_RST',
              identifiers: [
                'exterior-color'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          cameraMessages: [
            {
              message: 'CAMERA_STD_EXHAUST',
              identifiers: [
                'common_exterior'
              ],
              condition: '',
              isDefault: false,
              isStop: false
            }
          ],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ],
          notAvailableForColor: {
            interior: [],
            exterior: []
          }
        }
      },
      packages: {
        x7vtyrufcgr0: {
          groupId: 'high-country-pkg0',
          accessoryIds: [
            'u20m3d5j71vd'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'high-country-2025'
          ]
        },
        'x7vtyrufcgr0-my26': {
          groupId: 'high-country-pkg0',
          accessoryIds: [
            'u20m3d5j71vd'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'high-country-2026'
          ]
        },
        jv7fw2fjab9g: {
          groupId: 'high-country-pkg0',
          accessoryIds: [
            'hi5kmxzzzq9u',
            '54nn9olfhq0x'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ]
        },
        aypont1ipdwm: {
          groupId: 'high-country-pkg1',
          accessoryIds: [
            'rq9m3rn89rf904',
            'dk8i90myygvo'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [
              'sn7yhhtw36la',
              '0c7b3ow746eu',
              'fa1g6h4tgwqj',
              '8gq4d16o5mdp',
              'nwljddrqlbg2',
              'b8b7ndgwdafk',
              '1vsvpj5pgkpw'
            ]
          },
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ]
        },
        tc5utu4e26lj: {
          groupId: 'zr2-pkg0',
          accessoryIds: [
            'tbpzcy915xx3',
            'wh68ti5fisga',
            'h58thpxpqmpc',
            'u3zpsiu1n3nb',
            'th8zueo3valx',
            '15fp8hgbcwyv'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ]
        },
        '35nezp8v8im7': {
          groupId: 'zr2-pkg1',
          accessoryIds: [
            'aww7oooc9won',
            'n1g3jd1stqd5'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ]
        },
        '6zyk48o23wh4': {
          groupId: 'trail-boss-crew-cab-pkg0',
          accessoryIds: [
            '8fipb3d7mw06'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [
              'in0qtipuluw7',
              'v6j91ri0v3fw',
              '5t6ycv9d6u2a',
              'pu8ndfz3yuww',
              'hvd0le9te38d',
              'b1u0be790w3j',
              'ci15itsmn8cs',
              'sm9i3x2ykh53'
            ]
          },
          relevantVariants: [
            'trail-boss-crew-cab-2025'
          ]
        },
        '6zyk48o23wh4-my26': {
          groupId: 'trail-boss-crew-cab-pkg0',
          accessoryIds: [
            '8fipb3d7mw06'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [
              'in0qtipuluw7-my26',
              'v6j91ri0v3fw',
              '5t6ycv9d6u2a',
              'pu8ndfz3yuww',
              'hvd0le9te38d',
              'b1u0be790w3j',
              'ci15itsmn8cs-my26',
              'sm9i3x2ykh53-my26'
            ]
          },
          relevantVariants: [
            'trail-boss-crew-cab-2026'
          ]
        },
        vo9k10vqq8pc: {
          groupId: 'trail-boss-pkg0',
          accessoryIds: [
            '9v54hle0okz0'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: [
              '92seq27kicp4',
              'uwetia14dlwx',
              'cyxr36xkp8lj',
              'ss2t8loc0zuj',
              'ew6nnknehod2',
              '6dyaosyo71jo',
              'ew6nnknehoe8',
              'ew6nnknehod0'
            ]
          },
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ]
        },
        ep1xd71oo073: {
          groupId: 'trail-boss-pkg0',
          accessoryIds: [
            'zmvz8kuaprfi'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ]
        },
        '1hjssljlu8nl': {
          groupId: 'rst-crew-cab-pkg0',
          accessoryIds: [
            '2qvaqumopcbw',
            'mzckwh973o1y',
            '6xej21dk4z8n',
            'l0mv3qhmi42a'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ]
        },
        z6ushx99342q: {
          groupId: 'rst-pkg0',
          accessoryIds: [
            '7nvudf5dm6vl',
            '69b99z5t9il4',
            'wtyvo38z3fe1',
            'vwiga2uaok0o'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ]
        },
        lv8qzqdsgiws: {
          groupId: 'lt-crew-cab-4wd-pkg0',
          accessoryIds: [
            'h9cjgpp9xv7e',
            '7k8pshah93ij',
            'n58nvecii5t2',
            '9p8hhjnpsfhp'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ]
        },
        syyctxz5vsvj: {
          groupId: 'lt-4wd-pkg0',
          accessoryIds: [
            '0ln8s93srv7z',
            '0w8gce7si79p',
            '4hj05h5lb75y',
            'edt07rmrzik9'
          ],
          dependencyPackages: [],
          notAvailableForColor: {
            interior: [],
            exterior: []
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        }
      },
      interactions: {
        a8jlgfd8evx4: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOOR_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOOR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ]
        },
        e33wj494id3s: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ]
        },
        auuqx6b61pgx: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ]
        },
        rgbpeckqo7cp: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ]
        },
        '9s6k4y4lxbsv': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ]
        },
        ygh8bahl10yi: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'high-country-2025',
            'high-country-2026'
          ]
        },
        '7p1u0cgedxiz': {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOOR_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOOR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ]
        },
        '39rwrhudo7hr': {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ]
        },
        de5h612h79it: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'SUNROOF_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 4.7123,
                beta: 1.6118,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ]
        },
        '3chny1l2b6r2': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ]
        },
        nytakn7lnev4: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ]
        },
        sbo7fpqvwzuh: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'zr2-2025',
            'zr2-2026'
          ]
        },
        '8dvmfe5qick4': {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOOR_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOOR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ]
        },
        bjq73d6ex5uw: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ]
        },
        '9n0dvsx9qfuz': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ]
        },
        sx4la8gfy2lv: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ]
        },
        '4pfn931mbalz': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'trail-boss-crew-cab-2025',
            'trail-boss-crew-cab-2026'
          ]
        },
        m34u55h0srjx: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOOR_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOOR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ]
        },
        '4igcs67fpy6q': {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ]
        },
        wvjqyjf609w7: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ]
        },
        byq3h8qvfcna: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ]
        },
        ylgt9jtql60o: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'trail-boss-2025',
            'trail-boss-2026'
          ]
        },
        sk4ftvul6hgw: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOOR_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOOR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ]
        },
        vlasgxry3r2e: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ]
        },
        zso5wardx2cd: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ]
        },
        hl5i6bzdfwt5: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ]
        },
        ied6kma987aw: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-crew-cab-2025',
            'rst-crew-cab-2026'
          ]
        },
        ekb9gx2zypw8: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOOR_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOOR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ]
        },
        zywf2eknfbem: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ]
        },
        d188lhzd6pv5: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ]
        },
        abs0r5w715lo: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ]
        },
        f2zs0kah65on: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'rst-2025',
            'rst-2026'
          ]
        },
        '80v66cmn04mn': {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOOR_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'cab_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOOR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'cab_exterior'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ]
        },
        gdp46rwbpnl4: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ]
        },
        jrqcidowfqam: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ]
        },
        u5q2l78gqsx3: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ]
        },
        bb19do072c46: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-crew-cab-4wd-2025',
            'lt-crew-cab-4wd-2026'
          ]
        },
        xbdzchklx04d: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOOR_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOOR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        '9a4ewd0iqpwk': {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color',
                'bed_variant'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        bkr8amy2tvbs: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        '6146uzbd6kui': {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        iq7p37hq4g0j: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-4wd-2025',
            'lt-4wd-2026'
          ]
        },
        me1n6qt2sdto: {
          type: 'basic',
          view: [
            'exterior',
            'interior'
          ],
          startMessages: [
            {
              message: 'DOOR_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DOOR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {
                alpha: 5.1023,
                beta: 1.3902,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5
              }
            }
          },
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ]
        },
        y06f4jy4mex5: {
          type: 'basic',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            },
            {
              message: 'MULTIFLEX_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'cab_exterior',
                'interior-color',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ]
        },
        b5a9285d5gby: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ]
        },
        zndj3hh8v5aq: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ]
        },
        pcp7lp7oh1rc: {
          type: 'basic-light',
          view: [
            'exterior'
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color'
              ],
              waitForFulfill: false,
              cascade: true
            }
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 5,
                isBlend: true,
                blendInSeconds: 1.5
              }
            },
            interiorCamera: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {}
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {}
            }
          },
          relevantVariants: [
            'lt-rwd-2025',
            'lt-rwd-2026'
          ]
        }
      },
      hotspots: {
        exteriorCamera: {
          type: 'exterior',
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            upperRadiusLimit: 6.7,
            lowerRadiusLimit: 3.2,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            target: {
              x: 0,
              y: 0.65,
              z: 0
            },
            isFovZoomModeOn: false
          }
        },
        interiorCamera: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_1: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_2',
            identifiers: [
              'common_exterior'
            ]
          }
        },
        interiorCamera_2: {
          type: 'interior',
          messages: {}
        }
      },
      usdzPathWithVariable: ''
    }
  }
};
